import { SimpleCarousel } from 'components/AdGrids/SimpleCarousel';
import { Link } from 'components/Toolkit/Button/Link';
import { SimpleErrorBoundary } from 'helpers/SimpleErrorBoundary';

import * as Styled from 'components/HomePage/styles/HomePage.styled';
import type { RecentAdsProps } from 'features/landing/RecentAds/RecentAds.typed';

const RecentAds = (props: RecentAdsProps) => {
  const { cdnUrl, domain, recentAds, recentAdsUrl } = props;
  return (
    <div className="row small-collapse medium-uncollapse set-width-100">
      <div className="columns small-12">
        <Styled.Container isCarousel={true}>
          <Styled.SectionHeader>
            <Styled.Heading>Recent Ads</Styled.Heading>
            {recentAdsUrl && (
              <Link href={recentAdsUrl} ofType="SECONDARY" underline>
                <Styled.SLinkPadding>See All</Styled.SLinkPadding>
              </Link>
            )}
          </Styled.SectionHeader>
          <SimpleErrorBoundary>
            <SimpleCarousel
              ads={recentAds}
              cdnUrl={cdnUrl}
              domain={domain}
              variant="XS"
              orientation="VERTICAL"
              numberOfCards={8}
              testId="recent-ads-list"
            />
          </SimpleErrorBoundary>
        </Styled.Container>
      </div>
    </div>
  );
};

export { RecentAds };
